import { useQuery } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";

export type BrowserConfig = {
  userPilotToken: string;
};
export function useBrowserConfig() {
  return useQuery<BrowserConfig>({
    queryKey: ["browser-config"],
    staleTime: Infinity,
    queryFn: async () => {
      const { data } = await bffAxios.get<BrowserConfig>("/public-config");

      return data;
    },
  });
}
